export const isKeyOf = <T extends object>(
  key: PropertyKey,
  obj: T,
): key is keyof T => key in obj

export const isPartOfEnum = <T extends Record<string, string>>(
  enumObject: T,
  value: unknown,
): value is T[keyof T] =>
  typeof value === 'string' && Object.values(enumObject).includes(value)

export const typedKeys = <T extends object>(obj: T): (keyof T)[] =>
  Object.keys(obj) as (keyof T)[]
